import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


import { isNull, isEqual, isArray } from "lodash";

import {hasProperty, formatText, formatDate} from '../utils/utils';
import {cloneObject, getParam, truncate} from '../utils/utils';

import D3Graphviz from "../components/D3Graphviz";


import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewProcess from "../components/ViewProcess";
import ViewStep from "../components/ViewStep";
import Buffering from "../components/Buffering";
import { zipProcess } from "../utils/utilsProcess";
import { getProcessVersion } from "../utils/utilsProcess";


class ViewProcessVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };


        this.handleControls = this.handleControls.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleExport = this.handleExport.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

        this.setup();
 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props.params, prevProps.params)){
            this.setup();
        }

     }



    setup(){

        let StateChange = {
            idVersion: null,
            idProcess: null,
            type: null,
            Process: null,
            isLoaded: false,
            isFailed: false, 

            dot: null,

            Controls: {
                vizSwimlanes: false,
                vizArtefacts:false,
            }

        }

        StateChange.idVersion = getParam('idVersion', this.props);

        StateChange.idProcess = getParam('idProcess', this.props);

        StateChange.isExporting = false;
        this.setState(StateChange);

        this.loadData(StateChange.idProcess, StateChange.idVersion);

    }

    loadData(id, idVersion){

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Process = data;
            StateChange.isLoaded = true;
            this.setState(StateChange);
            return;
        }.bind(this);

        var onFail = function(e){
            let StateChange = {};
            StateChange.Process = null;
            StateChange.isFailed = true;

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);


        if (id){
            getProcessVersion(this.dsd, id, idVersion, onLoad, onFail);
        }

        this.fetchViz(id, idVersion);

        return;
    }


    fetchViz(id, idVersion) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getProcessVersion(this.dsd, id, idVersion, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };



    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});


        this.fetchViz(this.state.idProcess, this.state.idVersion);

        return;

    }


    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let Process = cloneObject(this.state.Process); 
            let Version = Process.Version;
            let idProcess = this.state.idProcess;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipProcess(this.dsd, Process);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `process_${idProcess}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }


    render() {

        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.isLoaded){
            return(
                <div>
                    <PD.Heading>{`Process: ${this.state.Process.name}`}</PD.Heading>
                    {this.state.Process.Version &&
                        <>
                           {this.viewVersion(this.state.Process.Version)}
                        </>
                    }
                    {this.viewProcess(this.state.Process)}
                </div>
            )
        }
        return <Buffering/>;

    };    

    viewVersion(Version){

        if (Version){
            return(
                <fieldset>
                    <legend>Named Version</legend>
                    <PD.Table className="panel">
                        <PD.Tbody>                                

                            {hasProperty(Version,'name') &&
                                <PD.Tr>                                
                                    <PD.Th>Name</PD.Th><PD.Td>{Version.name}</PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'description') &&
                                <PD.Tr>
                                    <PD.Th>Description</PD.Th>
                                    <PD.Td>
                                        <PD.MdPresent>
                                            {Version.description}
                                        </PD.MdPresent>                                    
                                    </PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'createdAt') &&
                                <PD.Tr>
                                    <PD.Th>Date/Time</PD.Th><PD.Td>{formatDate(Version.createdAt,'dmy hms')}</PD.Td>
                                </PD.Tr>
                            }

                        </PD.Tbody>
                    </PD.Table>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                </fieldset>
                
            )
        };
        return null;
    };

    viewProcess(Process){
        if (Process){

            let countSteps = 0;
            if (Process.Steps){
                if (Process.Steps.length){
                    countSteps = Process.Steps.length;
                }
            }


            const onChangeVizControl = function(event){

                const FormFieldName = event.target.name;
                let FormFieldValue = event.target.value;

                if (event.target.type == "checkbox"){
                    FormFieldValue = event.target.checked;
                }

                let Controls = this.state.Controls;
                Controls[FormFieldName] = FormFieldValue;
                this.setState({Controls:Controls}, () => {
                    this.fetchViz(this.state.idProcess, this.state.idVersion);
                });
            }.bind(this);


            return(
                <div>
                    <ViewProcess Process={Process} noLinks/>

                    <fieldset>
                        <legend>visualisation</legend>
                        <div>
                            Swimlanes <input type="checkbox" name="vizSwimlanes" onChange={onChangeVizControl}  checked={this.state.Controls.vizSwimlanes}/>
                        </div>
                        <div>
                            Artefacts <input type="checkbox" name="vizArtefacts" onChange={onChangeVizControl}  checked={this.state.Controls.vizArtefacts}/>
                        </div>
                        <D3Graphviz dot={this.state.dot}/>
                    </fieldset>

                    <PD.Heading level="2">Index</PD.Heading>

                    {countSteps &&
                        <fieldset>
                            <legend>Steps</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Process.Steps.map(
                                            (Step, pos) => 
                                            {                
                                                switch (Step.status){
                                                    case 'deprecated': return null;
                                                    default:

                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#step_${Step._id}`} onClick={this.handleNavClick}>{Step.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Step.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>
                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    <fieldset>
                        <legend>Renditions</legend>
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Type</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>
                            <PD.Tbody>
                                {/* BPMN export does not yet have layout infomation
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_bpmn`} onClick={this.handleNavClick}>BPMN</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                **/}
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_mermaid`} onClick={this.handleNavClick}>Mermaid</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_xpdl`} onClick={this.handleNavClick}>XPDL</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_dot`} onClick={this.handleNavClick}>DOT</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>

                            </PD.Tbody>
                        </PD.Table>
                    </fieldset>

                    {
                        countSteps &&
                            <div>
                                <PD.Heading level="2">Steps</PD.Heading>
                                {
                                    Process.Steps.map(
                                        (Step, pos) =>    
                                        {
                                            
                                            switch (Step.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset key={pos} id={`step_${Step._id}`}>
                                                            <ViewStep Step={Step} noLinks/>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }


                    <PD.Heading level="2">Renditions</PD.Heading>
                    {this.viewBPMN()}
                    {this.viewMermaid()}
                    {this.viewXPDL()}
                    {this.viewDOT()}

                </div>
            )
        }
    }

    viewBPMN(){

        return(
            <fieldset id={`rendition_bpmn`}>
                <legend>BPMN</legend>
                <ViewBPMN dsd={this.dsd} idProcess={this.state.idProcess} idVersion={this.state.idVersion}/>
            </fieldset>
        )
    }
    
    viewMermaid(){

        return(
            <fieldset id={`rendition_mermaid`}>
                <legend>Mermaid</legend>
                <ViewMermaid dsd={this.dsd} idProcess={this.state.idProcess} idVersion={this.state.idVersion}/>
            </fieldset>
        )
    }
    viewXPDL(){

        return(
            <fieldset id={`rendition_xpdl`}>
                <legend>XPDL</legend>
                <ViewXPDL dsd={this.dsd} idProcess={this.state.idProcess} idVersion={this.state.idVersion}/>
            </fieldset>
        )
    }
    viewDOT(){

        return(
            <fieldset id={`rendition_dot`}>
                <legend>DOT</legend>
                <ViewDOT dsd={this.dsd} idProcess={this.state.idProcess} idVersion={this.state.idVersion} Controls={this.state.Controls}/>
            </fieldset>
        )
    }
 
};
   
class ViewBPMN extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idProcess: null,
            isLoaded: false,
            isFailed: false, 
            BPMN: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idProcess = getParam('idProcess', this.props);

        if (StateChange.idProcess && StateChange.idVersion){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.BPMN = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.BPMN = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getProcessVersion(dsd,StateChange.idProcess,StateChange.idVersion, onLoad, onFail,'bpmn')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {this.state.BPMN}
                </pre>
            )
        }
        return <div/>
    }

};

class ViewMermaid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idProcess: null,
            isLoaded: false,
            isFailed: false, 
            Mermaid: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idProcess = getParam('idProcess', this.props);

        if (StateChange.idProcess && StateChange.idVersion){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.Mermaid = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.Mermaid = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getProcessVersion(dsd,StateChange.idProcess,StateChange.idVersion, onLoad, onFail,'mermaid')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {this.state.Mermaid}
                </pre>
            )
        }
        return <div/>
    }

};


class ViewXPDL extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idProcess: null,
            isLoaded: false,
            isFailed: false, 
            XPDL: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idProcess = getParam('idProcess', this.props);

        if (StateChange.idProcess && StateChange.idVersion){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.XPDL = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.XPDL = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getProcessVersion(dsd,StateChange.idProcess,StateChange.idVersion, onLoad, onFail,'xpdl')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {this.state.XPDL}
                </pre>
            )
        }
        return <div/>
    }

};


class ViewDOT extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idProcess: null,
            Controls: null,
            isLoaded: false,
            isFailed: false, 
            DOT: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idProcess = getParam('idProcess', this.props);
        StateChange.Controls = getParam('Controls', this.props);

        if (StateChange.idProcess && StateChange.idVersion){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.DOT = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.DOT = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getProcessVersion(dsd,StateChange.idProcess,StateChange.idVersion, onLoad, onFail,'dot',null,StateChange.Controls)
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {this.state.DOT}
                </pre>
            )
        }
        return <div/>
    }

};

export default function ViewProcessVersion_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewProcessVersion {...props} navigation={navigation} location={location} params={params} />;
  }
